var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Skeleton as PFSkeleton } from '@patternfly/react-core/dist/dynamic/components/Skeleton';
import classNames from 'classnames';
import '../Skeleton/skeleton.css';
export var SkeletonSize = { xs: 'xs', sm: 'sm', md: 'md', lg: 'lg' };
var Skeleton = function (_a) {
    var _b;
    var _c = _a.size, size = _c === void 0 ? SkeletonSize.md : _c, _d = _a.isDark, isDark = _d === void 0 ? false : _d, className = _a.className, props = __rest(_a, ["size", "isDark", "className"]);
    return (_jsx(PFSkeleton, __assign({ className: classNames('ins-c-skeleton', "ins-c-skeleton__".concat(size), (_b = {}, _b["ins-m-dark"] = isDark, _b), className) }, props)));
};
export default Skeleton;
//# sourceMappingURL=Skeleton.js.map